<div class="chat-container">
	<div class="chat-messages" #scrollContainer>
		<ng-container *ngFor="let message of messages">
			<!-- RECEIVED -->
			<div class="msg-row received" *ngIf="message.payload.direction=='Received'">
				<img class="avatar" src="assets/images/Panda%20-%20Icon%20(Dark%20Background).png" style="background-color: #0f1e3b;" />
				<div class="bubble">
					<p class="author">POH</p>
					<p class="chat-text" [innerHTML]="message.content"></p>
					<button *ngFor="let item of message.links"  nz-button nzType="dashed" [routerLink]="[item.link]">{{item.text}}</button>
				</div>
			</div>

			<!-- SENT -->
			<div class="msg-row sent" *ngIf="message.payload.direction=='Sent'">
				<div class="bubble">
					<p class="author">{{ authedUser.firstName }} {{ authedUser.lastName }}</p>
					<p class="chat-text">{{message.payload.message}}</p>
				</div>
			</div>
		</ng-container>
		<div class="msg-row sent" *ngIf="sending">
			<div class="bubble">
				<p class="author">{{ authedUser.firstName }} {{ authedUser.lastName }}</p>
				<p class="chat-text">
					{{ outgoing }}
					<br/>
				</p>
			</div>
		</div>
		<div class="msg-row received" *ngIf="sending">
			<div class="bubble">
				<p class="author">
					<nz-icon nzType="sync" [nzSpin]="true" />
					Working
				</p>
			</div>
		</div>
	</div>

	<div class="chat-input">
		<textarea [(ngModel)]="outgoing" placeholder="Type your message…" [disabled]="sending"></textarea>
		<button nz-button nzType="primary" (click)="send()" [disabled]="sending || !outgoing!.trim()">
			<span *ngIf="sending==false">Send</span>
			<span *ngIf="sending==true">Sending</span>
		</button>
	</div>
</div>
